import { gql, useMutation } from '@apollo/client';
import { ServiceTicket, ServiceTicketStatus } from './useServiceTicketsQuery';

const SERVICE_TICKET_UPDATE_STATUS = gql`
  mutation ServiceTicketUpdateStatus($id: ID!, $status: String!) {
    serviceTicketUpdateStatus(id: $id, status: $status) {
      id
      status
      resolvedAt
      updatedAt
    }
  }
`;

export interface ServiceTicketUpdateStatusVariables {
  id: string;
  status: ServiceTicketStatus;
}

export interface ServiceTicketUpdateStatusData {
  serviceTicketUpdateStatus: Pick<ServiceTicket, 'id' | 'status' | 'resolvedAt' | 'updatedAt'>;
}

export function useServiceTicketUpdateStatusMutation() {
  return useMutation<ServiceTicketUpdateStatusData, ServiceTicketUpdateStatusVariables>(SERVICE_TICKET_UPDATE_STATUS);
}
